<div class="flex" [class.w-full]="variant === 'sidebar-footer'">
  <!-- Button -->
  @if (variant === "sidebar-footer") {
    <button
      class="sidebar-user-trigger group flex w-full items-center gap-3 rounded-lg p-2 text-left transition-colors duration-150 hover:bg-hover"
      [disabled]="!isSsoEnabled"
      mat-menu-icon
      [matMenuTriggerFor]="userActions"
    >
      <span class="relative">
        @if (loginDisplay() && profilePhoto()) {
          <img
            class="size-5 rounded-xl object-cover shadow-lg"
            [src]="profilePhoto()"
            alt="User Avatar"
          />
        } @else {
          <mat-icon
            class="mt-0.5 size-5 rounded-xl"
            [svgIcon]="'heroicons_outline:user-circle'"
          ></mat-icon>
        }
        @if (workingStatus) {
          <span
            class="absolute -right-1 -top-1 h-3 w-3 rounded-full border-2 border-white dark:border-neutral-800"
            [class.bg-green-500]="workingStatus.status === 'available'"
            [class.bg-yellow-500]="workingStatus.status !== 'available'"
          ></span>
        }
      </span>
      <span class="sidebar-user-copy min-w-0 flex-1">
        <span class="block truncate text-sm font-medium leading-5">
          {{ user()?.givenName || user()?.displayName || "Account" }}
        </span>
        <span class="text-secondary block truncate text-xs leading-4">
          {{ user()?.mail || "Signed in" }}
        </span>
      </span>
    </button>
  } @else {
    <button
      class="group flex items-center gap-4 rounded-xl p-1 transition-colors duration-200 hover:bg-hover"
      [disabled]="!isSsoEnabled"
      mat-menu-icon
      [matMenuTriggerFor]="userActions"
    >
      <span class="relative">
        @if (loginDisplay() && profilePhoto()) {
          <img
            class="size-5 rounded-xl object-cover shadow-lg"
            [src]="profilePhoto()"
            alt="User Avatar"
          />
        } @else {
          <mat-icon
            class="mt-0.5 size-5 rounded-xl"
            [svgIcon]="'heroicons_outline:user-circle'"
          ></mat-icon>
        }
        @if (workingStatus) {
          <span
            class="absolute -right-1 -top-1 h-3 w-3 rounded-full border-2 border-white dark:border-neutral-800"
            [class.bg-green-500]="workingStatus.status === 'available'"
            [class.bg-yellow-500]="workingStatus.status !== 'available'"
          ></span>
        }
      </span>
    </button>
  }

  <mat-menu
    class="rounded-md p-1 min-w-48 shadow-md border"
    [xPosition]="variant === 'sidebar-footer' ? 'after' : 'before'"
    [yPosition]="variant === 'sidebar-footer' ? 'above' : 'below'"
    #userActions="matMenu"
  >
    <div class="p-2 min-h-8 rounded-md font-medium flex items-center gap-2">
      <span class="relative">
        @if (loginDisplay() && profilePhoto()) {
          <img
            class="size-8 object-cover shadow-lg rounded-xl"
            [src]="profilePhoto()"
            alt="User Avatar"
          />
        } @else {
          <mat-icon
            class="size-8 rounded-xl mt-0.5"
            [svgIcon]="'heroicons_outline:user-circle'"
          ></mat-icon>
        }
      </span>
      <span class="leading-none max-w-40 truncate">
        <p class="mb-0.5">{{ user()?.givenName }}</p>
        <small class="text-secondary">{{ user()?.mail }}</small>
      </span>
    </div>
    <div class="border-b my-1"></div>
    <button
      [routerLink]="['settings/profile']"
      mat-menu-item
      class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
    >
      Profile
    </button>

    @if (workingStatus) {
      <button
        [matMenuTriggerFor]="status"
        class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
        mat-menu-item
      >
        {{
          workingStatus?.status === "available"
            ? "In the office"
            : "Working remotely"
        }}
      </button>
    }
    <button
      [matMenuTriggerFor]="themeToggle"
      class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
      mat-menu-item
    >
      Theme ({{ currentTheme | titlecase }})
    </button>

    <button
      (click)="openDialog()"
      class="hover:bg-hover px-2 py-1.5 min-h-8 rounded-md"
      mat-menu-item
    >
      Business card
    </button>
    <button
      [routerLink]="['changelog']"
      class="hover:bg-hover px-2 py-1.5 min-h-8 rounded-md"
      mat-menu-item
    >
      <span class="flex items-center justify-between w-full">
        <span>Changelog</span>
        <span class="text-xs text-secondary ml-2">{{ appVersion }}</span>
      </span>
    </button>
    <div class="border-b my-1"></div>
    <button
      mat-menu-item
      (click)="signOut()"
      class="hover:bg-hover px-2 py-1.5 min-h-8 rounded-md"
    >
      Log out
    </button>
  </mat-menu>

  <mat-menu class="rounded-md p-1 min-w-36 shadow-md border" #status="matMenu">
    <button
      (click)="setWorkingStatus('available')"
      class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
      [class.bg-hover]="workingStatus?.status === 'available'"
      mat-menu-item
    >
      Office
    </button>
    <button
      class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
      [class.bg-hover]="workingStatus?.status === 'not-available'"
      (click)="setWorkingStatus('not-available')"
      mat-menu-item
    >
      Remote
    </button>
  </mat-menu>

  <mat-menu
    class="rounded-md p-1 min-w-36 shadow-md border"
    #themeToggle="matMenu"
  >
    <button
      (click)="setTheme('light')"
      [class.bg-hover]="currentTheme === 'light'"
      class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
      mat-menu-item
    >
      Light
    </button>
    <button
      (click)="setTheme('dark')"
      [class.bg-hover]="currentTheme === 'dark'"
      class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
      mat-menu-item
    >
      Dark
    </button>
    <button
      (click)="setTheme('system')"
      [class.bg-hover]="currentTheme === 'system'"
      class="hover:bg-hover dark:hover:text-white px-2 py-1.5 min-h-8 rounded-md"
      mat-menu-item
    >
      System
    </button>
  </mat-menu>
</div>
